import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export const RequireAuth = ({ children, admin }) => {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) return <div className="py-32 text-center text-slate-400" data-testid="auth-loading">جارِ التحميل...</div>;
  if (!user) return <Navigate to="/login" replace state={{ from: location.pathname + location.search }} />;
  if (admin && !user.is_admin) return <div className="py-32 text-center" data-testid="admin-forbidden">هذه الصفحة مخصصة لإدارة الموقع.</div>;
  return children;
};
